import Constants from './ConstantsForms';

export default {
    Constants
}


// WEBPACK FOOTER //
// ./src/pages/General/Defination/forms/index.js